module.exports = __webpack_public_path__ + "files/479f832889a36a36bd1be3a8b4965262.png";